import styled, { css } from "styled-components";

export const Wrap = styled.div`
  ${({ theme }) => css`
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    ${theme.media.small} {
      min-width: 0;
      width: 100%;
    }
  `}
`;

export const MainStyle = styled.main`
  ${({ theme }) => css`
    background-color: ${theme.color.background.default};

    display: flex;
    flex-direction: column;
    flex: 1;

    padding: ${theme.layout.desktop.contents.padding};

    ${theme.media.small} {
      padding: 0;
    }
  `}
`;

export const ContentsStyle = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: ${theme.layout.desktop.contents.width};
    margin: 0 auto;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-items: center;

    & > * {
      width: 100%;
    }

    ${theme.media.small} {
      width: 100%;
      flex: 1;
    }
  `}
`;
